import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Loader } from '../../components/Loader';
import { ensure, notificationChoreType } from '../../constants';
import { EVO } from '../../EVO';
import * as actions from "../../redux/ensure";
import { urls } from '../../urls';
import './NotificationChoreVersions.css';
import { NCDSummary } from './Summary';

const NCV = props => {
    const [versions, setVersions] = useState([]);
    const [timezone, setTimezone] = useState('');
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        let postEnsure = ensure.appointmentCategory + ensure.practitioner + ensure.appointmentModelProperties + ensure.smsCredits +
            ensure.business + ensure.billableItems + ensure.sexes + ensure.medicalAlerts + ensure.ptProducts;
        if (props.notificationChoreType === notificationChoreType.Email) {
            postEnsure += ensure.cmEmails;
        }
        dispatch(actions.ensure(postEnsure));
    }, []);

    useEffect(() => {
        const id = EVO.getParamsId(props);
        EVO.fetch(urls.api.notificationchores.getVersions(id))
            .then(response => {
                setLoading(false);
                setVersions(response.versions);
                setTimezone(response.timezone || '');
            })
            .catch(error => {
                setLoading(false);
                console.error(error);
            });
    }, [])

    return <Loader loading={loading}>
        <div> {EVO.any(versions) && <div>
            {versions.map(l => <div key={l.id} className="ncv-wrapper">
                <Formik
                    initialValues={l}
                    onSubmit={() => { }}>
                    {() =>
                        <Form>
                            <NCDSummary ncd={l} showActive={true} showModified={true} timezone={timezone} />
                        </Form>
                    }
                </Formik>
            </div>)}
            </div>}
        </div>
    </Loader>
};

export const NotificationChoreVersion = withRouter(NCV);


// WEBPACK FOOTER //
// ./src/pages/NotificationChore/NotificationChoreVersions.js